import SessionEventProto from "../session-event-proto";
import {SESSION_PROJECT_USERS_CHANGED} from "../../gd/bus/bus-event-type";


export default class EventProjectUsersResetByProject extends SessionEventProto {


    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {

        if (!this.data) {
            // how come ? :)
            return
        }

        if (this.isDifferentCompany()) return false;

        const { projectId } = this.data[0];
        const project = gd.session.projects.get(projectId);

        if (!project) {
            //this event is passed to every user in company, backend makes no
            //difference even if user is not supposed to get this event

            /*gd.utils.captureErrorMessage('EventProjectUsersResetByProject - no project found', {
                level: 'error', // one of 'info', 'warning', or 'error'
                extra: {
                    projectId: projectId,
                    data: this.data,
                    dataJsonData: JSON.stringify(this.data)
                }
            });*/
            return;
        }

        if (project.isTemplate) return; // no users for template projects



        // gd.session.projectUsers.resetAndKeepOldModels(this.data, {projectId: projectId})

        gd.session.projectUsers.resetByProject(project.id, this.data)

        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED, {projectId: projectId})

        // super.process();

    }
}

//
// module.exports = class EventProjectUsersResetByProject extends EventActionProto {
//
//     constructor(uid, data) {
//         super(uid, data);
//     }
//
//     validate() {
//         return true;
//     }
//
//     process() {
//         if (this.data) {
//
//             const { projectId } = this.data[0];
//             const project = gd.session.projects.get(projectId);
//
//             if (!project) {
//                 //this event is passed to every user in company, backend makes no
//                 //difference even if user is not supposed to get this event
//
//                 /*gd.utils.captureErrorMessage('EventProjectUsersResetByProject - no project found', {
//                     level: 'error', // one of 'info', 'warning', or 'error'
//                     extra: {
//                         projectId: projectId,
//                         data: this.data,
//                         dataJsonData: JSON.stringify(this.data)
//                     }
//                 });*/
//                 return;
//             }
//
//             if (project.isTemplate) return; // no users for template projects
//
//             // not needed here ? old ? see resetByProject  gd.session.projectUsers.resetByProjec
//             // // Experimental
//             // this.data.map(d=>{
//             //     const { userId, access } = d;
//             //     if (gd.session.me.id === userId && project.access !== access) {
//             //         project.access = access;
//             //     }
//             // });
//
//             // console.log("EventProjectUsersResetByProject process", this.data);
//
//             gd.session.projectUsers.resetAndKeepOldModels(this.data, {projectId: projectId})
//             gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED, {projectId: projectId})
//
//             super.process();
//         }
//     }
//
//
// };